import { createSlice } from '@reduxjs/toolkit';
import { BalikovnaStateType } from 'src/types/balikovna';
import { formatData } from './functions';

const initialState: BalikovnaStateType = {
    loading: false,
    data: null,
    error: false,
};
export const balikovnaSlice = createSlice({
    name: 'balikovna',
    initialState,
    reducers: {
        getBalikovnaFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getBalikovnaFetchSuccess: (state, action) => {
            state.data = formatData(action.payload);
            state.loading = false;
        },
        getBalikovnaFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getBalikovnaFetch, getBalikovnaFetchSuccess, getBalikovnaFetchFailure } = balikovnaSlice.actions;

export default balikovnaSlice.reducer;
